import React from 'react';
import {
  ComposedChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Area,
  Bar,
  Line,
  ResponsiveContainer
} from 'recharts';

const AreaChart = ({ data }) => {
  // Check if data is available
  if (!data || data.length === 0) {
    return <p>No data available</p>;
  }

  // Prepare the data for the chart
  const heatMapData = data.map((item) => ({
    name: item.AreaName,
    orderCount: item.OrderCount,
    totalSales: item.TotalSales,
    percentage: item.Percentage,
  }));

  return (
    <ResponsiveContainer width="100%" height={400}>
      <ComposedChart
        data={heatMapData}
        margin={{
          top: 20,
          right: 20,
          bottom: 20,
          left: 20,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />

        {/* Bar chart for OrderCount */}
        <Bar dataKey="TotalSales" barSize={20} fill="#8884d8" />

        {/* Line chart for OrderCount (or a different dataKey) */}
        <Line type="monotone" dataKey="OrderCount" stroke="#ff7300" />

        {/* Area chart for TotalSales */}
        <Area
          type="monotone"
          dataKey="totalSales"
          fill="#8884d8" stroke="#8884d8"
        />

        {/* Bar chart for Percentage */}
        <Bar dataKey="percentage" barSize={20} fill="#ff7300" />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default AreaChart;
